import * as React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface Props {
  folderId?: string;
  familyCount: number;
  ungroupedCount: number;
  reviewCount: number;
  onReview?: () => void;
}

export const ContractFamiliesToolbar: React.FC<Props> = ({
  folderId,
  familyCount,
  ungroupedCount,
  reviewCount,
  onReview,
}) => (
  <div className="flex flex-col gap-3 border-b border-slate-200 bg-white px-4 py-3 md:flex-row md:items-center md:justify-between">
    <div className="min-w-0">
      <h1 className="text-base font-semibold text-slate-950">Contract Families</h1>
      <p className="truncate text-xs text-slate-500">{folderId ? `Folder ${folderId}` : "All accessible folders"}</p>
    </div>
    <div className="flex flex-wrap items-center gap-2">
      <Badge variant="outline" className="rounded-md px-2 py-0.5">
        {familyCount} families
      </Badge>
      <Badge variant="outline" className="rounded-md px-2 py-0.5">
        {ungroupedCount} ungrouped
      </Badge>
      {reviewCount > 0 && onReview ? (
        <Button type="button" size="sm" variant="outline" onClick={onReview}>
          Review documents
          <Badge variant="traffic-amber" className="ml-2 rounded-md px-1.5 py-0">
            {reviewCount}
          </Badge>
        </Button>
      ) : null}
    </div>
  </div>
);
